import * as React from 'react';
import { Link, useLocation } from "react-router-dom";

export default function Preview() {
    const location = useLocation();

    React.useEffect(() => {
        document.title = (document as any).rootTitle;
    }, []);

    return (
        <div className="width-limit">
            <p className="fs-3 mt-0">Preview of new cards</p>
            <div className="row g-3 mb-3">
                <div className="col-12 col-md-6">
                    <Link to={'/preview/choice' + location.search}
                        className={'text-decoration-none btn btn-light btn-lg'}>
                        <h2>Choose the right option</h2>
                        <p className="fs-5">hoose the right meaning of the phrase from four options. Best for preview of new cards.</p>
                    </Link>
                </div>

                <div className="col-12 col-md-6">
                    <Link to={'/preview/recollect' + location.search}
                        className="text-decoration-none btn btn-light btn-lg">
                        <h2>Recollect or choose</h2>
                        <p className="fs-5">Recollect the meaning and assess your knowledge. If you cannot recollect you can show the options.</p>
                    </Link>
                </div>
            </div>
        </div>
    );
}
